/**
 * A dust bunny (or, for higher values, a bigger pile of debris).
 *
 *   value 1 — small, 70% of natural spawns
 *   value 2 — death-drop dust along a corpse trail
 *   value 3 — medium, 25% of natural spawns
 *   value 8 — large, 5% of natural spawns
 */
export class DustBunny {
  x: number;
  y: number;
  r: number;
  seed: number;
  value: number;

  constructor(x: number, y: number, value = 1) {
    this.x = x;
    this.y = y;
    this.value = value;
    this.r = radiusForValue(value);
    this.seed = Math.random() * 1000;
  }
}

function radiusForValue(v: number): number {
  if (v >= 8) return 17;
  if (v >= 3) return 13;
  if (v >= 2) return 11;
  return 10;
}
